import React, { useMemo } from 'react';

import { Alert, LinearProgress, Typography } from '@mui/material';

import ResultsGrid from './ResultsGrid';
import type { SearchResults, SubmittedSearch } from './types';

type FindSimilarAccountsContentProps = {
  data: SearchResults | undefined;
  error: Error | null;
  isBusy: boolean;
  submittedSearch?: SubmittedSearch | null;
};

export default function FindSimilarAccountsContent({
  data,
  error,
  isBusy,
  submittedSearch,
}: FindSimilarAccountsContentProps) {
  const { seedAccounts = [], similarAccounts = [] } = data ?? {};

  const results = useMemo(() => {
    return [...seedAccounts, ...similarAccounts];
  }, [seedAccounts, similarAccounts]);

  if (!isBusy && !error && submittedSearch && seedAccounts.length === 0) {
    return (
      <Alert severity="info" sx={{ mb: 3 }}>
        No accounts found for <strong>{submittedSearch.value}</strong>.
      </Alert>
    );
  }

  return (
    <>
      {isBusy && <LinearProgress sx={{ mb: 2 }} />}

      {error instanceof Error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error.message}
        </Alert>
      )}

      {results.length > 0 && (
        <>
          <Alert severity="error" sx={{ mb: 3 }}>
            <Typography variant="body2">
              Please note that these are ONLY suggestions, and standard confirmation processes must still be carried out
              through verification methods.
            </Typography>
          </Alert>
          <ResultsGrid rows={results} title={`Results (${results.length})`} />
        </>
      )}
    </>
  );
}
